import ImagesMainBannerMarchNewDesignSpiritoryArdbegAppWebp from '@/public/images/main-banner/march-new-design/spiritory-ardbeg-app.webp';

export { ImagesMainBannerMarchNewDesignSpiritoryArdbegAppWebp };
